import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor — auth is carried by the httpOnly cookie. On a session
// expiry (401) clear the cached user and bounce to login (but never bounce on a
// failed login attempt itself, which legitimately returns 401).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    if (error.response && error.response.status === 401 && !url.includes('/auth/login')) {
      localStorage.removeItem('user');
      window.location.href = '/wholesale/login';
    }
    return Promise.reject(error);
  }
);

export default api;
